













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Tab extends Vue {
  @Prop({ default: 'bucp-tab--active' })
  public activeClass!: string;

  @Prop()
  public isActive!: boolean;

  @Prop()
  public label!: string;

  public getActiveClass(): string {
    return this.isActive ? this.activeClass : '';
  }
}
